import React from 'react'

import { Box, Typography } from "@mui/material"


export default function doorsColumn() {

	return {
		name: 'doors',
		label: 'N˚ of Doors',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{value || "Any"}</Typography>
			</Box>,
		}
	}
}